module.exports = __webpack_public_path__ + "static/img/banner-2.aa5b16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-2.jpg
// module id = MsBi
// module chunks = 7